// Authoritative playtest tuning. Guest ink is awarded once per retained guest identity.
export const GUEST_INK = 250;
export const DAILY_INK = 1000;
export const INK_AREA = 250;
